"use strict";

var _defineProperty = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;

var _react = _interopRequireWildcard(require("react"));

var _player = _interopRequireDefault(require("@vimeo/player"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Video = function Video(_ref) {
  var providerUid = _ref.providerUid,
      _ref$paddingBottom = _ref.paddingBottom,
      paddingBottom = _ref$paddingBottom === void 0 ? '56.25%' : _ref$paddingBottom,
      _ref$vimeoOptions = _ref.vimeoOptions,
      vimeoOptions = _ref$vimeoOptions === void 0 ? {
    title: false,
    controls: true,
    byline: false,
    autoplay: true,
    autopause: false,
    muted: true,
    loop: true
  } : _ref$vimeoOptions;
  var videoContainer = (0, _react.useRef)(null);
  var player = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!player.current && providerUid) {
      player.current = new _player.default(videoContainer.current, _objectSpread({
        id: providerUid
      }, vimeoOptions));
    }
  }, [providerUid]);
  return _react.default.createElement(_styles.Container, null, _react.default.createElement(_styles.Content, null, providerUid && _react.default.createElement(_styles.VideoContainer, {
    ref: videoContainer,
    paddingBottom: paddingBottom
  })));
};

exports.Video = Video;